// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__il68u","left":"styles_left__Y7iRl","desktopActions":"styles_desktopActions__CNapC","title":"styles_title__2rqeG"};